import React, { useEffect, useState } from "react";
import { getUserDetails, addCrewUser, getCrewUserById } from "../API";
import { toast } from "react-toastify";
import icon1 from "../assets/images/numberSort.png";
import icon2 from "../assets/images/alphabetSort.png";
import iconAlpha from "../assets/images/alphabetSort-blue.png";
import iconNum from "../assets/images/numberSort-blue.png";

const AddNewTeamMemberModal = (props) => {
  const {
    crew_id,
    crewUsers,
    toggleAddNewMember,
    setToggleAddNewMember,
    allSelectedUsers,
    setAllSelectedUsers,
  } = props;

  const [addUserList, setAddUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [isNotUserSelected, setIsNotUserSelected] = useState(true);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [hoverImage, setHoverImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const tableHeading = [
    {
      img: icon1,
      label: "Id",
      sortBy: "number",
      hoverImg: iconNum,
    },
    {
      img: icon2,
      label: "Name",
      sortBy: "name",
      hoverImg: iconAlpha,
    },
  ];

  const handleMouseEnter = (index) => {
    setHoverImage(index);
  };
  const handleMouseLeave = (index) => {
    setHoverImage(null);
  };

  const getAllUsers = async () => {
    try {
      setIsLoading(true);
      await getUserDetails().then((res) => {
        if (res?.status === 200) {
          const filteredUsers = res?.data
            .filter((userItem) => {
              const crewUser = crewUsers?.find(
                (crewUser) => crewUser?.label === userItem?.name
              );
              return userItem?.name !== crewUser?.label;
            })
            ?.filter((userItem) => {
              const selectedUser = allSelectedUsers?.find(
                (ele) => userItem?.id === ele?.value?.user_id
              );
              return selectedUser?.value?.user_id !== userItem?.id;
            });
          setAddUserList(filteredUsers);
        }
      });
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (toggleAddNewMember) {
      getAllUsers();
    }
  }, [toggleAddNewMember, allSelectedUsers]);

  const handleSort = (column) => {
    setSortColumn(column);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const sortedUserList = [...addUserList].sort((a, b) => {
    const valueA = sortColumn === "name" ? a.name : a.id;
    const valueB = sortColumn === "name" ? b.name : b.id;

    if (sortOrder === "asc") {
      return typeof valueA === "string"
        ? valueA.localeCompare(valueB)
        : valueA - valueB;
    } else {
      return typeof valueB === "string"
        ? valueB.localeCompare(valueA)
        : valueB - valueA;
    }
  });

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredUserList = sortedUserList.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(item.employee_id).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onSubmitSelectedUser = async (userData) => {
    setIsLoading(true);
    const crewUserPayload = {
      crew_id,
      user_id: userData?.id,
    };
    const userPayload = {
      ...crewUserPayload,
      crew_role_id: 4,
      type: "adhoc",
    };
    await getCrewUserById(crewUserPayload).then(async (res) => {
      setIsLoading(false);
      if (res?.data?.length > 0) {
        const addedUser = {
          label: res?.data[0]?.user?.name,
          value: {
            crew_user_id: res?.data[0]?.id,
            user_id: res?.data[0]?.user?.id,
          },
        };
        setAllSelectedUsers((prevState) => [...prevState, addedUser]);
        setToggleAddNewMember(false);
        setSelectedUser({});
        setIsNotUserSelected(true);
        setSearchTerm("");
        toast.success("User added in the crew");
      } else {
        await addCrewUser(userPayload)
          .then(async (res) => {
            if (res?.status === 200) {
              const crewUserPayload = {
                id: res?.data?.id,
                };
                await getCrewUserById(crewUserPayload).then((res) => {
                setIsLoading(false);
                const addedUser = {
                  label: res?.data[0]?.user?.name,
                  value: {
                    crew_user_id: res?.data[0]?.id,
                    user_id: res?.data[0]?.user?.id,
                  },
                };
                setAllSelectedUsers((prevState) => [...prevState, addedUser]);
                setToggleAddNewMember(false);
                setSelectedUser({});
                setIsNotUserSelected(true);
                setSearchTerm("");
                toast.success("User added in the crew");
              });
            }
          })
          .catch((err) => {toast.error("Unable to add new user")
            setIsLoading(false);
          });
      }
    });
  };

  return (
    <>
      <div
        className="modal fade add-new-equipment-modal"
        id="addNewTeamMember"
        tabIndex="-1"
        aria-labelledby="addNewTeamMemberLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="addNewTeamMemberLabel"
              >
                Add New Team Member
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setToggleAddNewMember(false);
                  setSelectedUser({});
                  setIsNotUserSelected(true);
                  setSearchTerm("");
                }}
              ></button>
            </div>
            <div className="modal-body">
              <>
                <div className="search-bar mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>

                {/* <div className="sorting-buttons mb-3">
                  <button type="button" className="btn btn-secondary" onClick={() => handleSort("name")}>
                    Sort by Name
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => handleSort("id")}>
                    Sort by ID
                  </button>
                </div> */}

                <div className="table-responsive">
                  <table className="table crew-modal-table">
                    <thead>
                      <tr>
                        {tableHeading?.length > 0 &&
                          tableHeading?.map((item, index, key) => (
                            <th scope="col" className="heading" key={key}>
                              {item.label}
                              <img
                                onClick={() => handleSort(item.sortBy)}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                                src={
                                  hoverImage === index
                                    ? item.hoverImg
                                    : item.img
                                }
                                className="img-fluid icon ml-3"
                                alt=""
                              />
                            </th>
                          ))}
                      </tr>
                    </thead>
                    {!isLoading && (
                      <tbody>
                        {filteredUserList?.map((item, key) => {
                          return (
                            <tr
                              className={
                                selectedUser?.id === item.id ? "activeRow" : ""
                              }
                              onClick={() => {
                                setSelectedUser(item);
                                setIsNotUserSelected(false);
                              }}
                              key={key}
                            >
                              <td>{item.employee_id}</td>
                              <td>{item.name}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    )}
                  </table>
                </div>
              </>
            </div>
            <div
              className="modal-footer"
              style={{ justifyContent: "space-between" }}
            >
              <div>
                {isLoading && (
                  <div className="ddd">
                    <div className="spinner-border" role="status"></div>
                  </div>
                )}
              </div>
              <button
                disabled={isNotUserSelected}
                data-bs-dismiss="modal"
                type="button"
                className={
                  !isNotUserSelected ? "primary-btn" : "disabled-submit-btn"
                }
                aria-label="Close"
                onClick={() => onSubmitSelectedUser(selectedUser)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewTeamMemberModal;
